var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuefinder-file-previewer"},[_c(_vm.preview[_vm.type] || _vm.preview['default'],{tag:"component",attrs:{"url":_vm.url,"path":_vm.path}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }